import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Grid, Stack, Button, CircularProgress, Typography, Divider } from '@mui/material';
import AuthCardWrapper from '../AuthCardWrapper';
import OnboardingLayout from 'layout/OnboardingLayout';
import LogoBg from '../../../../assets/images/logo_bg.png';
import AuthLogin from '../auth-forms/AuthLogin';

const Login = () => {
    return (
        <OnboardingLayout
            title="Welcome Back"
            subtitle="Enter your credentials to continue"
            imageSrc={LogoBg}
            hideStepper={true} // hide steps
            hideBackButton={true} // hide back button
        >
            <Grid container justifyContent="center">
                <AuthCardWrapper>
                    <Stack spacing={3} sx={{ width: '100%', maxWidth: 450 }}>
                        <AuthLogin />
                        <Divider sx={{ my: 2 }} />
                        <Typography
                            component={Link}
                            to="/register"
                            variant="subtitle1"
                            sx={{ textDecoration: 'none', display: 'block', textAlign: 'center' }}
                        >
                            Don&apos;t have an account?
                        </Typography>
                    </Stack>
                </AuthCardWrapper>
            </Grid>
        </OnboardingLayout>
    );
};

export default Login;
